<script>
const FEATURES = [
  {
    id: 'blended',
    icon: 'chalkboard-teacher',
    title: 'Blended learning',
    description: 'Combinez des formations en ligne avec des sessions en présentiel pour offrir une expérience d\'apprentissage enrichie.',
  },
  {
    id: 'physical',
    icon: 'map-marker-alt',
    title: 'Événements physiques',
    description: 'Organisez des ateliers, séminaires et sessions de travail en ajoutant l\'adresse du lieu directement.',
  },
  {
    id: 'coaching',
    icon: 'user-friends',
    title: 'Séances de coaching',
    description: 'Planifiez des sessions d\'accompagnement individuel ou collectif avec vos apprenants.',
  },
  {
    id: 'webinars',
    icon: 'video',
    title: 'Webinaires et sessions en direct',
    description: 'Ajoutez un lien vers votre plateforme de visioconférence (Talkizy, Zoom, Meet...) pour des sessions en direct.',
  },
  {
    id: 'gamification',
    icon: 'trophy',
    title: 'Gamification',
    description: 'Donnez à vos apprenants une raison de revenir régulièrement en planifiant des événements récurrents.',
  },
  {
    id: 'milestones',
    icon: 'flag-checkered',
    title: 'Jalons de parcours',
    description: 'Marquez les dates clés de vos formations pour guider la progression de vos apprenants.',
  },
];

export default {
  head: {
    title: 'Pourquoi utiliser les événements ?',
  },
  data: () => ({
    features: FEATURES,
  }),
};
</script>

<template>
  <div>
    <div class="columns is-multiline">
      <div
        v-for="feature in features"
        :key="feature.id"
        class="column is-6 is-12-mobile"
      >
        <div class="box">
          <div class="media">
            <div class="media-left p-2 bradius-8 has-background-primary-light">
              <b-icon
                :icon="feature.icon"
                size="is-medium"
                type="is-primary"
              />
            </div>
            <div class="media-content">
              <h3 class="title is-5 mw-260">
                {{ feature.title }}
              </h3>
            </div>
          </div>
          <div class="content mt-5">
            <p>{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
